import React from "react";
import { createRoot } from "react-dom/client";
import TabsSection from "../components/TabsSection.js";

const renderTabsSection = ($, $context = $(document)) => {
	const tabs = $context.find(".js-tabs-section")[0];

	if (!tabs) return;

	const root = createRoot(tabs);
	const tabHeaders = $(tabs)
		.closest(".tabs-pattern")
		.find("h1[id]:not([id='']), h2[id]:not([id='']), h3[id]:not([id='']), h4[id]:not([id='']), h5[id]:not([id='']), h6[id]:not([id=''])")
		.toArray();

	const props = {
		...tabs.dataset,
		tabHeaders,
	};
	root.render(<TabsSection {...props} />);
};

export default renderTabsSection;
